<template>
  <v-dialog v-model="show" persistent max-width="600px">
    <v-card v-if="U != null">
      <v-toolbar color="amber lighten-2" dark>
        <v-toolbar-title class="headline">Inställningar</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-flex>
            <v-flex cols="12" sm="6">
              <v-text-field
                label="Namn"
                hint="Här kan du ändra ditt namn"
                v-model="U.name"
              ></v-text-field>
            </v-flex>
            <v-flex cols="12" sm="6">
              <v-text-field
                label="Mailadress"
                hint="Här kan du ändra din mailadress"
                v-model="U.mail"
              ></v-text-field>
            </v-flex>
            <v-flex cols="12" sm="6">
              <v-text-field
                label="Nytt lösenord"
                hint="Här kan du ändra ditt lösenord"
                type="password"
                v-model="U.newPassword"
              ></v-text-field>
            </v-flex>
          </v-flex>

          <v-flex v-if="As == 'EHT'">
            <v-select
              v-model="workdays"
              :items="days"
              multiple
              attach
              chips
              label="Arbetsdagar"
              hint="Vilka dagar arbetar du?"
            ></v-select>

            <v-flex v-if="workdays.length != 0">
              <h2>Arbetstider</h2>
              <v-container grid-list-md text-xs-center>
                <v-layout row wrap>
                  <v-flex
                    xs3
                    v-for="(item, index) in workinghours"
                    :key="index"
                  >
                    <v-text-field
                      :label="workdays[index]"
                      hint="Skriv dina arbetstider här"
                      v-model="workinghours[index]"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
            <v-textarea
              outline
              label="Beskrivning"
              hint="Beskriv dig själv och hur just du arbetar."
              v-model="U.description"
            ></v-textarea>
          </v-flex>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn dark color="red darken-1" @click="show = false"> Avbryt </v-btn>
        <v-btn color="green lighten-1" text dark @click="SaveUser()">
          Ändra
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import sha512 from "crypto-js/sha512";
export default {
  name: "Settings",
  watch: {
    workdays: function (val) {
      if (this.workinghours.length > this.workdays.length) {
        for (let i = this.workdays.length; i < this.workinghours.length; i++) {
          this.workinghours.pop();
        }
      } else if (this.workdays.length == this.workinghours.length) {
      } else {
        for (let i = this.workinghours.length; i < val.length; i++) {
          this.workinghours.push("");
        }
      }
    },
  },
  computed: {
    ...mapGetters("ehtmembers", ["member"]),
    ...mapGetters("teachers", ["teacher"]),
    ...mapGetters("cases", ["cases", "casesnames"]),
    show: {
      get() {
        this.User = null;

        if (this.value != this.dialog) {
          if (this.As == "teacher") {
            //  (this.teacher)
            this.User = this.teacher;
          } else if (this.As == "EHT") {
            //  (this.member)
            this.User = this.member;
            if (!this.User.hasOwnProperty("description")) {
              this.User.description = "";
            } else {
            }
            if (this.User.hasOwnProperty("workdays"))
              this.workdays = this.User.workdays;
            if (this.User.hasOwnProperty("workinghours"))
              this.workinghours = this.User.workinghours;
          }
          this.User.newPassword = "";
          this.OldUser = JSON.parse(JSON.stringify(this.User));
        }
        this.dialog = this.value;
        this.U = JSON.parse(JSON.stringify(this.User));
        // //console.log(this.U)
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  props: {
    As: String,
    value: Boolean,
  },
  data() {
    return {
      User: null,
      U: null,
      OldUser: null,
      dialog: false,
      workdays: [],
      workinghours: [],
      days: ["Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag"],
    };
  },
  methods: {
    EncryptPassword(Password) {
      return sha512(Password).toString();
    },
    ...mapActions(["showSuccessSnackbar", "showWarningSnackbar"]),
    ...mapActions("teachers", ["saveteacher"]),
    ...mapActions("ehtmembers", ["savemember"]),

    SaveUser() {
      this.User = this.U;
      if (this.User.hasOwnProperty("newPassword")) {
        if (this.User.newPassword != "") {
          this.User.password = this.EncryptPassword(this.User.newPassword);
        }
        delete this.User.newPassword;
      }

      if (
        this.User.name != this.OldUser.name ||
        this.User.mail != this.OldUser.mail ||
        this.User.password != this.OldUser.password
      ) {
        if (this.As == "teacher") {
          this.saveteacher(this.User);
        } else {
          this.User.workdays = this.workdays;
          this.User.workinghours = this.workinghours;
          this.savemember(this.User);
        }

        this.showSuccessSnackbar("Din info är uppdaterad!");
      } else if (
        (this.workdays.length != 0 && this.workinghours.length != 0) ||
        this.User.description != "" ||
        this.workdays.length != 0
      ) {
        this.User.workdays = this.workdays;
        this.User.workinghours = this.workinghours;
        this.savemember(this.User);
        this.showSuccessSnackbar("Din info är uppdaterad!");
      } else {
        this.showWarningSnackbar("Inget har ändrats.");
      }

      this.show = false;
    },
  },
};
</script>